<template>
  <div class="">
      <div class="row">
        <div class="col-lg-5 mt-5 m-left">
          <h1 class="title model-info">
            {{ name }}
          </h1>
          <h3 class="description mt-3 mb-4 model-info">
            {{ description }}
          </h3>
          <div
            v-for="(credit, i) in credits"
            :key="i"
            class="row mt-1 align-items-center justify-content-start model-info"
          >
            <div class="col-10 mx-2 label-function">
              <strong>{{ credit.functions }}</strong> : {{ credit.persons }}
            </div>
          </div>
        </div>
        <div class="col-lg-7 img-credits">
          <img class="img-perfil-model" :src="imgPerfil" :alt="name" srcset="" />
        </div>
      </div>
    </div>
</template>

<script lang="ts">
  export default {
    name: 'CreditsModel',
    props: ['model', 'translate'],
    created() {
    if (this.model) {
      this.getModel()
    }
  },
  watch: {
    'model': function () {
      this.getModel()
    }
  },
    data() {
      return {
        name: '',
        description: '',
        credits: [],
        imgPerfil: ''
      }
    },
    methods: {
      getModel() {
        this.name = this.model.nameModel
        this.description = this.model.descriptionModel
        this.text = this.model.text
        this.imgPerfil = this.model.imgPerfil
        this.perfilQuestion = this.model.profileQuestion
        this.credits = this.model.credits
      }
    }
  }
</script>
<style scoped lang="css">
  h3 h1 p {
    font-family: 'Exo-2';
  }

  h3 {
    font-weight: 600;
  }
  .label-function {
    color: #444444;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 32px;
  }

  .model-info {
    padding-left: 108px;
  } 

  .title {
    color: #000000;
    font-family: "Bebas-Neue";
    font-size: 72px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 72px;
  }

  .description {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }
  .row .buttons-video > .col,
  .row > [class*='col-'] {
    padding-right: 5px;
    padding-left: 5px;
  }

  .img-perfil-model {
    width: 100%;
    right: -5px;
  }

  .img-credits {
    padding-right: 17px !important;
  }


  @media screen and (max-width: 992px) {
    .img-credits {
      display: none;
    }
    .block {
      padding: 0px;
      margin-top: 0px;
    }

    .model-info {
      padding-left: 0px;
    } 

    .title {
      font-size: 56px;
      line-height: 56px;
    }

    .m-left {
      padding-left: 50px !important;
    } 
  }
</style>
